import { PORTLET_FETCH_SUCCESS } from '@core/js/components/system/Portlet';

export const initialState = {};

export default (reducerSuffix: string) => (state = initialState, action: { type: string, payload: any }) => {
    switch (action.type) {
        case PORTLET_FETCH_SUCCESS:
        case PORTLET_FETCH_SUCCESS + reducerSuffix: {
            const { response: { data } } = action.payload;

            return {
                ...state,
                data
            };
        }

        default:
            return state;
    }
};
